// extracted by mini-css-extract-plugin
export default {"containerTitle":"modal_containerTitle__5xUic","containerBtn":"modal_containerBtn__WFiJ5"};